import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, distinctUntilChanged, ReplaySubject } from 'rxjs';
import { IHierarchyMenuConfig } from '../../../components/menu/hierarchy-menu/hierarchy-menu.component';
import { RouteDataService } from '../../route-data/route-data.service';

@Injectable({
  providedIn: 'root',
})
export class HierarchyMenuService {
  private readonly enabledSubject$ = new BehaviorSubject<boolean>(false);
  public readonly enabled$ = this.enabledSubject$.asObservable();

  private readonly configSubject$ = new ReplaySubject<IHierarchyMenuConfig>();
  public readonly config$ = this.configSubject$.asObservable().pipe(distinctUntilChanged());

  constructor() {
    inject(RouteDataService).data$.subscribe((data) => {
      this.configSubject$.next(data);
      this.enabledSubject$.next(!!data.hierarchyMenu);
    });
  }
}
